import { NetworkMember } from "../../../../../Redux/referral/types";
import {
  AVATAR_FALLBACK,
  earningsStatusClass,
  formatEarningsCurrency,
  statusLabel,
} from "../../earningsAdapters";

interface Props {
  members: NetworkMember[];
}

const NovaLevelTeamTable = ({ members }: Props) => {
  return (
    <div className="ri-table-wrap ri-preserve-mobile-table">
      <div className="ri-mobile-table-note">
        Swipe horizontally to view complete table
      </div>
      <table className="ri-table ri-nova-level-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>MEMBER</th>
            <th>PARTNER NETWORK ID</th>
            <th>REFERRING PARTNER ID</th>
            <th>REFERRAL UPLINER</th>
            <th>JOINED DATE</th>
            <th>LEVEL</th>
            <th>STATUS</th>
            <th>NOVA COMMISSIONS</th>
          </tr>
        </thead>
        <tbody>
          {members?.map((member, index) => (
            <tr key={index}>
              <td className="ri-center">
                <strong>{member.sNo}</strong>
              </td>
              <td>
                <div className="ri-product-cell">
                  <img src={member.memberPhoto || AVATAR_FALLBACK} alt="" />
                  <div>
                    <p>
                      <b>{member.memberName || "—"}</b>
                    </p>
                  </div>
                </div>
              </td>
              <td className="ri-center">
                <strong>{member.partnerNetworkId || "—"}</strong>
              </td>
              <td className="ri-center">
                <strong>{member.referringPartnerId || "—"}</strong>
              </td>
              <td>
                <div className="ri-product-copy">
                  <strong>{member.referralUplinerName || "—"}</strong>
                  <span>{member.referralUplinerId || ""}</span>
                </div>
              </td>
              <td className="ri-center">
                <strong>{member.joinedDate || "—"}</strong>
              </td>
              <td className="ri-center">
                <strong>{member.level}</strong>
              </td>
              <td className="ri-center">
                <span className={earningsStatusClass(member.status)}>
                  {statusLabel(member.status)}
                </span>
              </td>
              <td className="ri-center">
                <div className="ri-incentive-lines">
                  <div className="ri-data-line">
                    <span>Gross</span>
                    <strong className="ri-money">
                      {formatEarningsCurrency(
                        member.receivedIncentiveDetails?.novaReferralCommission ??
                          member.receivedIncentiveDetails?.salarPearlsIncentives ??
                          0,
                      )}
                    </strong>
                  </div>
                  {member.receivedIncentiveDetails?.novaTdsAmount != null && (
                    <>
                      <div className="ri-data-line">
                        <span>
                          TDS
                          {member.receivedIncentiveDetails.novaTdsPercentage !=
                          null
                            ? ` (${member.receivedIncentiveDetails.novaTdsPercentage}%)`
                            : ""}
                        </span>
                        <strong>
                          -{" "}
                          {formatEarningsCurrency(
                            member.receivedIncentiveDetails.novaTdsAmount,
                          )}
                          {member.receivedIncentiveDetails.tdsIsEstimated
                            ? " (est)"
                            : ""}
                        </strong>
                      </div>
                      <div className="ri-data-line">
                        <span>Net</span>
                        <strong className="ri-money">
                          {formatEarningsCurrency(
                            member.receivedIncentiveDetails.novaNetIncentive ??
                              member.receivedIncentiveDetails
                                .novaReferralCommission ??
                              0,
                          )}
                        </strong>
                      </div>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
          {(!members || members.length === 0) && (
            <tr>
              <td colSpan={9} className="ri-center">
                No member data available for this milestone
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default NovaLevelTeamTable;
